<template>
    <div class="navPhone">
        <div class="hide" @click="hide=!hide">
            <img src="../../public/img/nav.png" width="100%" height="100%" alt="" srcset="">
        </div>
        <div class="box" v-show="!hide">
            <el-collapse class="tit" v-model="activeNames" @change="handleChange" >
                <el-collapse-item  :title="$t('首页')" name="1">
                    <div class="btn"><router-link to="/" style="margin-top:20px;">{{$t('首页')}}</router-link></div>
                </el-collapse-item>
                <el-collapse-item  :title="$t('navAbout')" name="1">
                    <div class="btn"><router-link to="/Introduction" style="margin-top:20px;">{{$t('誉诚简介')}}</router-link></div>
                    <div class="btn"><router-link to="/development" style="margin-top:20px;">{{$t('发展历程')}}</router-link></div>
                    <div class="btn"><router-link to="/Branch" style="margin-top:20px;">{{$t('分子公司')}}</router-link></div>
                    <div class="btn"><router-link to="/certificate" style="margin-top:20px;">{{$t('资质证书')}}</router-link></div>
                </el-collapse-item>
                <el-collapse-item  :title="$t('关于业务')" name="2">
                    <div class="btn"><router-link to="/domestic" style="margin-top:20px;">{{$t('国内业务')}}</router-link></div>
                    <div class="btn"><router-link to="/International" style="margin-top:20px;">{{$t('国际业务')}}</router-link></div>
                </el-collapse-item>
                <el-collapse-item  :title="$t('products')" name="3">
                    <div class="btn"><router-link to="/productClass" style="margin-top:20px;">{{$t('产品')}}</router-link></div>
                    <!-- <div class="btn"><router-link to="/Protection/Nursing" style="margin-top:20px;">{{$t('日常护理')}}</router-link></div> -->
                </el-collapse-item>
                <el-collapse-item  :title="$t('news')" name="4">
                    <div class="btn"><router-link to="/news" style="margin-top:20px;">{{$t('新闻动态')}}</router-link></div>
                    <div class="btn"><router-link to="/videoCenter" style="margin-top:20px;">{{$t('视频中心')}}</router-link></div>
                </el-collapse-item>
                <el-collapse-item  :title="$t('contact')" name="5">
                    <div class="btn"><router-link to="/contact" style="margin-top:20px;">{{$t('联系方式')}}</router-link></div>
                    <div class="btn"> <a href="https://xtyucheng.en.alibaba.com/zh_CN/?spm=a2700.icbuShop.88.10.526c4b3aQhdR7W" target="view_window" style="margin-bottom:20px;">{{$t('誉诚商城')}}</a> </div>
                </el-collapse-item>
                <el-collapse-item @click.native="setLang()"  title="中/EN" name="6">
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeNames: [],
            hide:true
        };
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        setLang(){
            this.$root.$i18n.locale == 'zh'?this.$root.$i18n.locale = 'en':this.$root.$i18n.locale = 'zh'
        }
    }

}
</script>
<style lang="less" scope>
.navPhone{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    min-height: 50px;
    width: 100%;
    .box{
        width: 100%;
        background-color: #fff;
    }
    .btn{
        margin-bottom: 10px;
    }
    .hide{
        width: 30px;
        height: 30px;
        position: absolute;
        right: 0;
        top: 0;
        border-radius: 0 0 0 5px;
        overflow: hidden;
    }
    .tit{
        width: 80%;
        margin: 0 auto;
    }
    a{
        text-decoration: none;
        line-height: 1.5rem;
        color: #848484;
        white-space: nowrap;
    }
    a:hover{
        color: #0578af;
    }
}
</style>
<i18n>
{
  "en": {
      "navAbout":"ABOUT US",
      "products":"PRODUCTS",
      "news":"NEWS",
       "contact":"CONTACT US",
       "誉诚简介":"YuCheng",
       "发展历程":"Development",
       "分子公司":"Branch",
       "资质证书":"Certificate",
       "医疗防护":"Medical Protection",
       "防护服":"Protective Suit",
       "防护服反光条":"Protective Clothing Seal",
       "手术衣":"Surgical Gown",
       "无纺布帽":"Non-woven Hat",
       "一次性鞋套":"Disposable Shoe Sover",
       "口罩":"Masks",
       "日常护理":"Daily Care",
       "酒店浴袍":"Hotel Bathrobe",
       "袖套":"Cuff",
       "工作服":"Work Clothes",
       "新闻动态":"News",
       "视频中心":"Video Center",
       "联系方式":"Contact Information",
       "誉诚商城":"Yucheng Mall",
       "关于业务":"BUSINESS",
       "国内业务":"Domestic Business",
       "国际业务":"International Business",
       "首页":"Home",
       "产品":"Product"       
  },
  "zh": {
       "navAbout":"关于誉诚",
       "products":"产品中心",
       "news":"新闻中心",
       "contact":"联系我们",
       "誉诚简介":"誉诚简介",
       "发展历程":"发展历程",
       "分子公司":"分子公司",
       "资质证书":"资质证书",
       "医疗防护":"医疗防护类",
       "防护服":"防护服",
       "防护服反光条":"防护服反光条",
       "手术衣":"手术衣",       
       "无纺布帽":"无纺布帽",
       "一次性鞋套":"一次性鞋套",
       "口罩":"口罩",
       "日常护理":"日常护理类",
       "酒店浴袍":"酒店浴袍",
       "袖套":"袖套", 
       "工作服":"工作服",
       "新闻动态":"新闻动态", 
       "视频中心":"视频中心",
       "联系方式":"联系方式",
       "誉诚商城":"誉诚商城",
       "关于业务":"关于业务",
       "国内业务":"国内业务",
       "国际业务":"国际业务",
       "首页":"首页",
       "产品":"产品"
       
    }
}
</i18n>